import { Box, BoxProps } from "@mui/material";
import React from "react";

export const PageReportsContainer = (props: BoxProps) => (
    <Box display="flex" sx={{ height: "100vh", width: "calc(100vw - 192px)", overflowY: "hidden" }}>
        {props.children}
    </Box>
);
